import { render, staticRenderFns } from "./family-member.vue?vue&type=template&id=2cf68a6e&"
import script from "./family-member.vue?vue&type=script&lang=js&"
export * from "./family-member.vue?vue&type=script&lang=js&"
import style0 from "./family-member.vue?vue&type=style&index=0&id=2cf68a6e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports